export default "__VITE_ASSET__jXRIo9XW__"